import { useQuery } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { ApiError, authApi } from "@/api/http";
import { Loading } from "@/components/ui";

/** Live mode: the pages open only with a session (cookie, or the dev header locally). */
export function Session({ children }: { children: ReactNode }) {
  const me = useQuery({ queryKey: ["me"], queryFn: authApi.me, retry: false });
  // A 401 already sends the browser to /login (see http.ts); any other failure must not hang on «Проверяем вход…».
  if (me.isError && !me.data) {
    const denied = me.error instanceof ApiError && me.error.status === 401;
    if (!denied)
      return (
        <div className="mx-auto max-w-md px-4 py-24" role="alert">
          <p className="font-medium">Не удалось проверить вход</p>
          <p className="mt-1 text-sm text-muted">Сервис не ответил. Это не значит, что вы вышли: попробуйте ещё раз.</p>
          <button type="button" className="btn-secondary mt-4" onClick={() => me.refetch()} disabled={me.isFetching}>
            {me.isFetching ? "Проверяем…" : "Повторить"}
          </button>
        </div>
      );
  }
  if (!me.data)
    return (
      <div className="mx-auto max-w-md px-4 py-24">
        <Loading label="Проверяем вход…" />
      </div>
    );
  return <>{children}</>;
}
